import { axiosClient } from './axiosClient';

const ReviewService = {
  /**
   * Create a new review
   * @param {Object} reviewData - { salon, appointment, rating, comment }
   */
  createReview: async (reviewData) => {
    const response = await axiosClient.post('/salons/reviews/', reviewData);
    return response.data;
  },

  /**
   * Get pending reviews for the current user
   * Optionally filtered by a specific salon.
   *
   * @param {number} [salonId] - Optional salon ID to filter appointments.
   * @returns {Promise<Array>} List of appointments that need to be reviewed
   */
  getPendingReviews: async (salonId) => {
    let url = '/salons/reviews/pending/';
    if (salonId) {
      url += `?salon_id=${salonId}`;
    }
    const response = await axiosClient.get(url);
    return response.data;
  },

  /**
   * Get reviews for a specific salon
   * @param {number} salonId
   */
  getSalonReviews: async (salonId) => {
    const response = await axiosClient.get(`/salons/reviews/?salon_id=${salonId}`);
    return response.data;
  },

  toggleHidden: async (reviewId) => {
    const response = await axiosClient.post(`/salons/reviews/${reviewId}/toggle_hidden/`);
    return response.data;
  }
};

export default ReviewService;
